module.exports = __webpack_public_path__ + "static/media/purpleblob.4fc7615c.svg";